module.exports = __webpack_public_path__ + "static/media/foodprint_app8_preview.b8bbf4b4.jpg";